import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';
import { RiderService } from '../riders/rider.service';
import { TrackingDashboard, TrackingService, TrackingUnit } from './tracking.service';

@Component({
  selector: 'app-logistics-tracking',
  templateUrl: './logistics-tracking.component.html',
  styleUrls: ['./logistics-tracking.component.scss']
})
export class LogisticsTrackingComponent implements OnInit {
  loading = false;
  dashboard: TrackingDashboard | null = null;
  units: TrackingUnit[] = [];
  riders: any[] = [];
  selectedStatus = 'all';
  ping = {
    riderId: null as number | null,
    trackingId: '',
    latitude: 6.5244,
    longitude: 3.3792,
    accuracyMeters: 15,
    batteryLevel: 80,
    source: 'manual'
  };

  constructor(
    private trackingService: TrackingService,
    private riderService: RiderService
  ) {}

  ngOnInit(): void {
    this.loadPage();
  }

  loadPage(): void {
    this.loading = true;
    forkJoin({
      dashboard: this.trackingService.getDashboard(),
      riders: this.riderService.getRiders()
    }).subscribe({
      next: ({ dashboard, riders }) => {
        this.dashboard = dashboard;
        this.units = dashboard?.units || [];
        this.riders = (riders || []).filter((row) => row?.isActive);
        if (!this.ping.riderId && this.riders.length) {
          this.ping.riderId = this.riders[0].id;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('[LogisticsTracking] ❌ Failed to load tracking page:', err);
        this.loading = false;
        Swal.fire('Error', err?.error?.message || 'Failed to load logistics tracking.', 'error');
      }
    });
  }

  get visibleUnits(): TrackingUnit[] {
    if (this.selectedStatus === 'all') return this.units;
    return this.units.filter((unit) => unit.status.toLowerCase() === this.selectedStatus);
  }

  get boardUnits(): TrackingUnit[] {
    return this.visibleUnits.filter((unit) => !!unit.recordedAt);
  }

  async savePing(): Promise<void> {
    if (!this.ping.riderId) {
      Swal.fire('Validation', 'Select a rider before saving a location ping.', 'warning');
      return;
    }

    this.trackingService.createPing(this.ping).subscribe({
      next: () => {
        Swal.fire('Saved', 'Tracking ping recorded successfully.', 'success');
        this.loadPage();
      },
      error: (err) => {
        console.error('[LogisticsTracking] ❌ Failed to save ping:', err);
        Swal.fire('Error', err?.error?.message || 'Failed to save tracking ping.', 'error');
      }
    });
  }

  statusTone(unit: TrackingUnit): string {
    if (unit.status === 'Live') return 'live';
    if (unit.status === 'Stale') return 'stale';
    return 'offline';
  }
}
